import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center justify-center gap-1 rounded-md px-2.5 py-0.5 text-xs font-semibold leading-none transition-all border',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-fg border-transparent',
        secondary: 'bg-secondary text-secondary-fg border-transparent',
        success: 'bg-success text-success-fg border-transparent',
        error: 'bg-error text-error-fg border-transparent',
        warning: 'bg-warning text-warning-fg border-transparent',
        info: 'bg-info text-info-fg border-transparent',
        outline: 'border-border-default text-text-primary bg-transparent',
        'outline-primary': 'border-primary text-primary bg-primary/8',
        'outline-success': 'border-success text-success bg-success/8',
        'outline-error': 'border-error text-error bg-error/8',
        'outline-warning': 'border-warning text-warning bg-warning/8',
        ghost: 'bg-bg-muted text-text-secondary border-transparent',
      },
      size: {
        sm: 'text-[10px] px-2 py-0.5',
        default: 'text-xs px-2.5 py-0.5',
        lg: 'text-sm px-3 py-1',
      },
      rounded: {
        default: 'rounded-md',
        full: 'rounded-full',
        none: 'rounded-none',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      rounded: 'default',
    },
  },
)
